import { USER_ROLES } from "../../utility/Enum";

export const STAFF_ROLES = [
  USER_ROLES.CLUB_ADMIN,
  USER_ROLES.TEAM_ADMIN,
  USER_ROLES.COACH,
];

export const canManageStaff = (user) =>
  Boolean(
    user?._id &&
      user?.club?._id &&
      user.club.clubAdminUsers?.some((id) => String(id) === String(user._id))
  );

export const getStaffRoleLabel = (role, t) =>
  t(
    {
      [USER_ROLES.CLUB_ADMIN]: "club_admin",
      [USER_ROLES.TEAM_ADMIN]: "team_admin",
      [USER_ROLES.COACH]: "coach",
    }[role] || role
  );

export const getStaffName = (user) =>
  [user?.firstName, user?.lastName].filter(Boolean).join(" ");

export {
  getUserActivity as getStaffActivity,
  readActivityStorageScope as readStaffStorageScope,
} from "../../utility/userActivity";

export const buildStaffDirectoryVariables = ({
  clubId,
  filters,
  page,
  pageSize,
}) => ({
  clubId,
  search: filters.search.trim() || undefined,
  role: filters.role || undefined,
  teamId: filters.teamId || undefined,
  skip: page * pageSize,
  limit: pageSize,
});
